var _rect, _rect2, _g, _circle, _mask, _path, _path2, _circle2, _path3, _path4, _circle3, _circle4, _circle5, _g2, _path5, _circle6, _circle7, _circle8, _g3, _rect3, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgIntroduction3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 346,
    viewBox: "0 0 508 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 508,
    height: 346,
    rx: 16,
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1599_10610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 69,
    width: 306,
    height: 277
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 69,
    width: 305.557,
    height: 277,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1599_10610)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1599_10610)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137.352,
    y: 69,
    width: 233.823,
    height: 370.393,
    rx: 42,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.852,
    y: 74.5,
    width: 222.823,
    height: 359.393,
    rx: 36.5,
    stroke: "#2B2B2B",
    strokeWidth: 11
  })), /*#__PURE__*/React.createElement("rect", {
    x: 209.691,
    y: 69,
    width: 89.145,
    height: 24.8881,
    rx: 12.444,
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1599_10610)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.034,
    y: 81.4434,
    width: 20.4595,
    height: 4.39201,
    rx: 2.19601,
    fill: "#666666"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178.972,
    cy: 217.972,
    r: 83.9721,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-1_1599_10610",
    maskUnits: "userSpaceOnUse",
    x: 240.056,
    y: 128,
    width: 109,
    height: 180,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 240.056,
    y: 128,
    width: 109,
    height: 180
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343 134.996C338.772 134.34 334.44 134 330.028 134C283.651 134 246.056 171.596 246.056 217.972C246.056 264.349 283.651 301.944 330.028 301.944C334.44 301.944 338.772 301.604 343 300.948V134.996Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343 134.996C338.772 134.34 334.44 134 330.028 134C283.651 134 246.056 171.596 246.056 217.972C246.056 264.349 283.651 301.944 330.028 301.944C334.44 301.944 338.772 301.604 343 300.948V134.996Z",
    fill: "#A5A5A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343 134.996H349V129.855L343.919 129.067L343 134.996ZM343 300.948L343.919 306.877L349 306.09V300.948H343ZM330.028 140C334.131 140 338.156 140.316 342.081 140.925L343.919 129.067C339.388 128.364 334.749 128 330.028 128V140ZM252.056 217.972C252.056 174.909 286.965 140 330.028 140V128C280.338 128 240.056 168.282 240.056 217.972H252.056ZM330.028 295.944C286.965 295.944 252.056 261.035 252.056 217.972H240.056C240.056 267.662 280.338 307.944 330.028 307.944V295.944ZM342.081 295.019C338.156 295.628 334.131 295.944 330.028 295.944V307.944C334.749 307.944 339.388 307.58 343.919 306.877L342.081 295.019ZM349 300.948V134.996H337V300.948H349Z",
    fill: "#F2F2F2",
    mask: "url(#path-8-outside-1_1599_10610)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.972,
    cy: 217.972,
    r: 83.9721,
    fill: "#3A7EFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.547 227.793V230.145C175.533 233.262 175.533 236.762 174.535 242.039L171.035 241.684C171.992 236.98 172.033 233.48 172.047 230.555H157.391V227.793H175.547ZM155.039 247.48V244.637H163.16V236.078H166.633V244.637H177.734V247.48H155.039ZM200.621 225.66V240.234H197.312V234.219H195.07V240.125H191.789V226.098H195.07V231.375H197.312V225.66H200.621ZM178.965 237.801C183.668 236.092 186.006 233.521 186.539 230.145H180.168V227.355H190.094C190.094 233.617 187.1 237.842 180.605 240.398L178.965 237.801ZM183.258 244.008V241.191H200.621V250.516H197.148V244.008H183.258Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.912 225.66V244.008H311.439V237.938H306.846V240.07H295.006V227.273H298.506V231.102H303.4V227.273H306.846V229.816H311.439V225.66H314.912ZM298.342 250.078V242.176H301.869V247.289H315.432V250.078H298.342ZM298.506 237.336H303.4V233.754H298.506V237.336ZM306.846 235.148H311.439V232.633H306.846V235.148ZM339.822 228.777V231.566H319.123V228.777H327.736V225.879H331.182V228.777H339.822ZM318.139 247.973V245.184H327.736V242.326C323.498 241.943 320.928 240.207 320.955 237.473C320.928 234.451 324.195 232.646 329.459 232.66C334.627 232.646 337.949 234.451 337.936 237.473C337.949 240.207 335.352 241.943 331.182 242.312V245.184H340.916V247.973H318.139ZM324.537 237.473C324.523 238.949 326.232 239.619 329.459 239.605C332.617 239.619 334.354 238.949 334.354 237.473C334.354 236.051 332.617 235.381 329.459 235.367C326.232 235.381 324.523 236.051 324.537 237.473ZM351.498 231.266C351.484 235.723 353.385 240.221 357.377 242.148L355.271 244.938C352.605 243.611 350.801 241.15 349.775 238.156C348.682 241.369 346.768 244.008 343.951 245.402L341.791 242.586C346.016 240.645 347.998 235.887 347.998 231.266V227.547H351.498V231.266ZM358.471 250.516V225.633H361.971V235.23H365.635V238.184H361.971V250.516H358.471Z",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.5,
    cy: 196.5,
    r: 15.5,
    fill: "#C8DBFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.96,
    cy: 192.159,
    r: 4.96,
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1599_10610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 314,
    y: 181,
    width: 31,
    height: 31
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 329.5,
    cy: 196.5,
    r: 15.5,
    fill: "#BDD4FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1599_10610)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 329.16,
    cy: 209.519,
    r: 11.16,
    fill: "#2B2B2B"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.792 198.442L326.5 207.386L329.305 210L332 207.386L330.689 198.463C330.189 198.395 329.679 198.359 329.16 198.359C328.697 198.359 328.24 198.388 327.792 198.442Z",
    fill: "#2D6AF6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 196.5,
    r: 15.5,
    fill: "#BCD3FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.96,
    cy: 192.159,
    r: 4.96,
    fill: "#6C8FD0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1599_10610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 181,
    width: 31,
    height: 31
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 196.5,
    r: 15.5,
    fill: "#87B1FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1599_10610)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 178.16,
    cy: 209.519,
    r: 11.16,
    fill: "#6C8FD0"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 26,
    width: 98,
    height: 48,
    rx: 10,
    fill: "#3A7EFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9619 42.4453V58H41.7178V45.5176H41.6318L38.0654 47.752V44.8945L41.9111 42.4453H44.9619ZM50.4619 58.1934C49.4521 58.1934 48.6357 57.3877 48.6572 56.3887C48.6357 55.4004 49.4521 54.5947 50.4619 54.6055C51.418 54.5947 52.2451 55.4004 52.2451 56.3887C52.2451 57.3877 51.418 58.1934 50.4619 58.1934ZM48.6572 48.2031C48.6357 47.2148 49.4521 46.4092 50.4619 46.4199C51.418 46.4092 52.2451 47.2148 52.2451 48.2031C52.2451 49.2021 51.418 50.0078 50.4619 50.0078C49.4521 50.0078 48.6357 49.2021 48.6572 48.2031ZM61.4834 42.4453V58H58.2393V45.5176H58.1533L54.5869 47.752V44.8945L58.4326 42.4453H61.4834ZM86.4697 40.4258V59.9766H83.8486V50.1152H82.0869V59.0742H79.4873V40.7051H82.0869V47.8809H83.8486V40.4258H86.4697ZM70.0771 55.0566V42.4453H77.8545V55.0566H70.0771ZM72.6338 52.9082H75.2979V44.6152H72.6338V52.9082ZM100.134 42.4668V44.6367H96.1377C96.2021 46.6348 97.7061 48.6436 100.843 49.4707L99.5752 51.5762C97.3193 50.9961 95.7295 49.7393 94.8164 48.1172C93.9463 49.9219 92.3457 51.3613 90.0146 52.0059L88.7041 49.8789C91.8193 49.0088 93.3018 46.8066 93.3662 44.6367H89.3701V42.4668H93.3662V40.4473H96.1592V42.4668H100.134ZM91.5186 56.2598C91.5078 53.918 94.0752 52.5537 98.2432 52.543C102.379 52.5537 104.946 53.918 104.968 56.2598C104.946 58.623 102.379 59.9873 98.2432 59.9766C94.0752 59.9873 91.5078 58.623 91.5186 56.2598ZM94.2686 56.2598C94.2686 57.3447 95.6113 57.8926 98.2432 57.8926C100.854 57.8926 102.25 57.3447 102.261 56.2598C102.25 55.2178 100.854 54.6592 98.2432 54.6699C95.6113 54.6592 94.2686 55.2178 94.2686 56.2598ZM102.153 52.2422V40.4473H104.903V52.2422H102.153Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1599_10610",
    x: 133.352,
    y: 69,
    width: 241.823,
    height: 378.393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1599_10610"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1599_10610",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1599_10610",
    x: 244.034,
    y: 81.4434,
    width: 21.4595,
    height: 5.39258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1599_10610"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgIntroduction3);
export default __webpack_public_path__ + "static/media/ImgIntroduction3.7a0fe6251f8059dbe351c0dd5c53fe86.svg";
export { ForwardRef as ReactComponent };